module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "prelims-page",
    attrs: {
      "id": "df42f5abd977e-d1e332"
    }
  }, [_c('span', {
    attrs: {
      "id": "pagev"
    }
  }, [_c('p', {
    staticClass: "dedication"
  }, [_vm._v("In memory of Ken Tutterow, President and CEO of the Children’s Home Society of North Carolina from 1990 to 2014, beloved friend, leader and advocate for the children of North Carolina. It was his mission to promote the right of every child to a permanent, safe and loving family. Thousands of foster children, adopted children and adoptive parents are leading happy lives today because of his good work.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4af261bd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781780107158_epub_ded.vue
// module id = 72
// module chunks = 0